import {
  dashboardUrl,
  candidateAccountUrl,
  saveLastSearchUrl,
  saveSearchUrl,
  jobMailUrl,
  saveJobUrl,
  saveJobSearchUrl,
  recommendedJobsUrl
} from 'config';
import createRequest from '../create-request';

const request = createRequest();

const localUrl = (locale, auUrl) => locale === 'NZ' ? auUrl.replace('.com.au', '.co.nz') : auUrl;

const dashboard = (locale, token) => request
  .get(localUrl(locale, dashboardUrl))
  .set('Authorization', token)
  .withCredentials()
  .then(response => response.body);

const recommendedJobs = (token, sessionId) => {
  return request
    .get(`${recommendedJobsUrl}/?maxJobs=3`)
    .set('Authorization', token)
    .set('x-seek-ec-sessionid', sessionId)
    .accept('application/json')
    .type('application/json')
    .then(response => response.body)
    .then(({ jobs, totalJobs }) => {
      const stripTime = date => {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
      };

      const formatDaysAgo = (date, today) => {
        const diff = stripTime(today) - stripTime(date);
        const daysAgo = Math.round(diff / (1000 * 60 * 60 * 24));

        return daysAgo > 30 ? `${30}+` : daysAgo.toString();
      };

      return {
        recommendedJobs: {
          data: jobs.map(({ id, title, advertiser, listed, isNew }) => ({
            id,
            title,
            advertiser: advertiser.description,
            daysAgo: formatDaysAgo(new Date(listed), new Date()),
            isNew
          })),
          totalCount: totalJobs
        }
      };
    });
};

const account = token => {
  return request
    .get(candidateAccountUrl)
    .set('Authorization', token)
    .accept('application/json')
    .type('application/json')
    .then(response => response.body);
};

const saveLastSearch = ({ locale, token }) => request
  .post(localUrl(locale, saveLastSearchUrl))
  .set('Authorization', token)
  .withCredentials()
  .send({ cookieName: 'main' })
  .then(response => response.body);

const saveSearch = ({ query, location }) => {
  const { locationId, areaId, whereId } = location || {};

  const searchQuery = {
    ...query,
    location: locationId,
    area: areaId,
    whereid: whereId,
    expandLocation: false // added temporarily until jobseeker can be updated to make it optional
  };

  return request
  .post(saveSearchUrl)
  .send(searchQuery)
  .withCredentials()
  .then(response => response.body);
};

const jobMail = ({ query, location, emailAddress }) => {
  const { locationId, areaId, whereId } = location || {};

  const searchQuery = {
    ...query,
    emailAddress,
    location: locationId,
    area: areaId,
    whereid: whereId
  };

  return request
  .post(jobMailUrl)
  .send(searchQuery)
  .then(response => response.body);
};

const saveJob = (jobId, token) => {
  const url = `${saveJobUrl}/${jobId}/shortlist`;

  return request
    .post(url)
    .set('Authorization', token)
    .then(response => response.body);
};

const removeSavedJob = (jobId, token) => {
  const url = `${saveJobUrl}/${jobId}/shortlist`;

  return request
    .del(url)
    .set('Authorization', token);
};

const searchSavedJobs = (jobIds, token) => {
  return request
    .post(saveJobSearchUrl)
    .send({ jobIds })
    .set('Authorization', token)
    .then(response => response.body);
};

export default {
  dashboard,
  recommendedJobs,
  account,
  saveLastSearch,
  saveSearch,
  jobMail,
  saveJob,
  removeSavedJob,
  searchSavedJobs
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/seek-jobs-api-client/apis/candidate.js
 **/